import { render } from "./StateAbortBuildingType.vue?vue&type=template&id=477b717e"
import script from "./StateAbortBuildingType.vue?vue&type=script&lang=js"
export * from "./StateAbortBuildingType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__